import { render, staticRenderFns } from "./insurance.vue?vue&type=template&id=e2e3c2b4&scoped=true&"
import script from "./insurance.vue?vue&type=script&lang=js&"
export * from "./insurance.vue?vue&type=script&lang=js&"
import style0 from "./insurance.vue?vue&type=style&index=0&id=e2e3c2b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e3c2b4",
  null
  
)

export default component.exports